import './Lighthouse.css'

import RealtimeDataWidget from './RealtimeDataWidget'
import EventsWidget from './EventsWidget'
import { useNavigate } from 'react-router-dom'
import { faBattery4 } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Breadcrumbs, Divider, Grid, Group, Stack, Text, ThemeIcon, Title } from '@mantine/core'


const DashboardComponent = () => {

    const navigate = useNavigate()

    return (
        <div className="flow-vertical fill-parent" style={{gap: 15}}>
            <Stack spacing={4}>
                <Group align="flex-end">
                    <Group mr={20} spacing={4}>
                        <ThemeIcon>
                            <FontAwesomeIcon icon={faBattery4} />
                        </ThemeIcon>
                        <Title order={2}>Lighthouse</Title>
                    </Group>
                    <Breadcrumbs mb={4} separator="/">
                        <Text size="sm" variant="link" component="a" onClick={() => navigate(".."+window.location.search)}>Dashboards</Text>
                        <Text size="sm" color="dimmed">Lighthouse</Text>
                    </Breadcrumbs>
                </Group>
                <Divider />
            </Stack>
            <Grid grow style={{height: "100%", overflow: "auto"}}>
                <Grid.Col md={7} lg={8} xl={9} style={{height: "100%", width: "50%"}}><RealtimeDataWidget/></Grid.Col>
                <Grid.Col md={5} lg={4} xl={3} style={{height: "100%"}}><EventsWidget/></Grid.Col>
            </Grid>
        </div>
    )
}

export default DashboardComponent